import { AgronomicInputs } from 'base/types/RecommendationCropwise';
import { isBrazil } from './countryCode';

export const getRankingCrop = (
  countryName: string,
  cropType: string,
  agronomicInputs: AgronomicInputs
): string => {
  if (isBrazil(countryName)) {
    return cropType.toLowerCase().includes('safra') ? 'CORNLATAMSUMMER' : 'CORNLATAMWINTER';
  }

  return agronomicInputs?.cropRanking || agronomicInputs?.extraInfo?.cropRegion || '';
};
